import { IRole } from './roles.model';
import { IRoleSite } from '../sites.state/sites.model';
import { IRoleUser } from '../user.state/users.model';
import { IZonePermission } from 'src/app/role-management/services/roles.service';

export class SetRole {
  static readonly type: string = '[Roles] Set';
  constructor(public role: IRole, public patchNewState: boolean = true) {}
}

export class SetAllRoles {
  static readonly type: string = '[Roles] SetAll';
  constructor(public roles: IRole[]) {}
}

export class RemoveRole {
  static readonly type: string = '[Roles] Remove';
  constructor(public roleId: number) {}
}

export class SetRoleDataLoaded {
  static readonly type: string = '[Roles] SetDataLoaded';
  constructor(public loading: boolean) {}
}

export class SetSelectedRole {
  static readonly type = '[Roles] SetSelectedRole';
  constructor(public role: IRole | null) {}
}

export class SetAssignedSites {
  static readonly type = '[Roles] SetAssignedSites';
  constructor(public sites: IRoleSite[]) {}
}

export class SetAllSites {
  static readonly type = '[Roles] SetAllSites';
  constructor(public sites: IRoleSite[]) {}
}

export class SetAssignedSiteCount {
  static readonly type = '[Roles] SetAssignedSiteCount';
  constructor(public count: number) {}
}

export class SetSelectedPermissionSite {
  static readonly type = '[Roles] SetSelectedPermissionSite';
  constructor(public site: IRoleSite | null) {}
}

export class SetAssignedUsers {
  static readonly type = '[Roles] SetAssignedUsers';
  constructor(public users: IRoleUser[]) {}
}

export class SetAllUsers {
  static readonly type = '[Roles] SetAllUsers';
  constructor(public users: IRoleUser[]) {}
}

export class SetAssignedZones {
  static readonly type = '[Roles] SetAssignedZones';
  constructor(public zones: IZonePermission[]) {}
}

export class SetAllZones {
  static readonly type = '[Roles] SetAllZones';
  constructor(public zones: IZonePermission[]) {}
}

export class ClearRoleSession {
  static readonly type = '[Roles] ClearRoleSession';
}
